/**
 * Advanced Search Validators
 * Zod schemas for saved searches and search history
 */
import { z } from "zod";
export const searchFilterSchema = z.object({
    field: z.string(),
    operator: z.enum(["equals", "contains", "startsWith", "endsWith", "gt", "gte", "lt", "lte", "between"]),
    value: z.union([z.string(), z.number(), z.tuple([z.number(), z.number()])]),
});
export const savedSearchSourceSchema = z.enum(["results", "favorites"]);
export const createSavedSearchSchema = z.object({
    name: z.string().min(1).max(100),
    description: z.string().max(500).optional(),
    source: savedSearchSourceSchema,
    filters: z.array(searchFilterSchema).min(1),
    isDefault: z.boolean().optional(),
});
export const updateSavedSearchSchema = z.object({
    name: z.string().min(1).max(100).optional(),
    description: z.string().max(500).optional(),
    filters: z.array(searchFilterSchema).min(1).optional(),
    isDefault: z.boolean().optional(),
});
//# sourceMappingURL=search.schema.js.map